// user namespace
export const RESET_TEMP_ENVIRONMENT = 'RESET_TEMP_ENVIRONMENT'
export const SET_CURRENT_ENVIRONMENT = 'SET_CURRENT_ENVIRONMENT'
export const SET_CURRENT_SUBSIDIARY = 'SET_CURRENT_SUBSIDIARY'
export const SET_TEMP_ENVIRONMENT = 'SET_TEMP_ENVIRONMENT'

// navigation namespace
export const SET_EXPAND_INPUT = 'SET_EXPAND_INPUT'
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'
export const SET_MOBILE_SEARCH = 'SET_MOBILE_SEARCH'
export const SET_DESK_SEARCH = 'SET_DESK_SEARCH'

// sidebar namespace
export const SET_CATEGORY = 'SET_CATEGORY'
export const SET_TAB = 'SET_TAB'
export const GET_NAVIGATION_ITEMS_PENDING = 'GET_NAVIGATION_ITEMS_PENDING'
export const GET_NAVIGATION_ITEMS_ERROR = 'GET_NAVIGATION_ITEMS_ERROR'
export const GET_NAVIGATION_ITEMS_SUCCESS = 'GET_NAVIGATION_ITEMS_SUCCESS'
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'

// screen namespace
export const UPDATE_BREAKPOINT = 'UPDATE_BREAKPOINT'

// delete action items namespace
export const SEND_DELETE_ITEMS_ERROR = 'SEND_DELETE_ITEMS_ERROR'
export const SEND_DELETE_ITEMS_PENDING = 'SEND_DELETE_ITEMS_PENDING'
export const SEND_DELETE_ITEMS_SUCCESS = 'SEND_DELETE_ITEMS_SUCCESS'
